function isScientificNotation(num: number) {
	const numberString = num.toString();
	const scientificNotationRegex = /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)$/;
	return scientificNotationRegex.test(numberString);
}

function parseCurrencyValue(str: string) {
	const regex = /^([^\d\s]+)\s*([\d.,]+)$/;
	const matches = str.match(regex);

	if (matches && matches.length === 3) {
		const currency = matches[1].trim();
		const value = parseFloat(matches[2].replace(/,/g, ''));
		return { currency, value };
	}
}

function countLeadingZeros(str: string) {
	let count = 0;
	for (let i = 0; i < str.length; i++) {
		if (str[i] === '0') {
			count++;
		} else {
			break;
		}
	}
	return count;
}

export default function formatCoinPrice(str: string) {
	const parsed = parseCurrencyValue(str);

	let decimalPart: string;
	let integerPart: string;
	let zeroAmount = 0;

	if (!parsed && str.split('').includes('.')) {
		integerPart = str.split('.')[0];
		decimalPart = str.split('.')[1];
		zeroAmount = countLeadingZeros(decimalPart);

		if (zeroAmount < 3) {
			return {
				initial: str,
				formatted: null,
			};
		}
		const truncated =
			decimalPart.substring(0, 1) + '..' + decimalPart.substring(zeroAmount, zeroAmount + 3);
		return {
			initial: str,
			formatted: `${integerPart}.${truncated}`,
		};
	}
	if (Number.isInteger(Number(parsed.value))) {
		return {
			initial: str,
			formatted: null,
		};
	} else {
		if (isScientificNotation(parsed.value)) {
			const formatted = parsed.value.toFixed(20);
			integerPart = formatted.split('.')[0];
			decimalPart = formatted.split('.')[1];
			zeroAmount = countLeadingZeros(decimalPart);
		} else if (parsed.value.toString().split('').includes('.')) {
			integerPart = parsed.value.toString().split('.')[0];
			decimalPart = parsed.value.toString().split('.')[1];
			zeroAmount = countLeadingZeros(decimalPart);
		}
		if (zeroAmount >= 4) {
			const truncated =
				decimalPart.substring(0, 1) + '..' + decimalPart.substring(zeroAmount, zeroAmount + 3);
			return {
				initial: str,
				formatted: `${parsed.currency} ${integerPart}.${truncated}`,
			};
		} else {
			return {
				initial: str,
				formatted: null,
			};
		}
	}
}
